var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-up"},[_c('auth-tabs'),_vm._v(" "),_c('div',{staticClass:"sign-up__content-wrapper"},[_c('sign-up-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }